module.exports = __webpack_public_path__ + "static/sankey-ab9e7ccfc932b43bc268045fdcd45d4e.png";